import client from "./client";

const schoolTimingsApi = {
  async getAll() {
    const { data } = await client.get("/school-timings");
    return data;
  },

  async getActive() {
    const { data } = await client.get("/school-timings/active");
    return data;
  },

  async getById(id) {
    const { data } = await client.get(`/school-timings/${id}`);
    return data;
  },

  async create(payload) {
    const { data } = await client.post("/school-timings", payload);
    return data;
  },

  async update(id, payload) {
    const { data } = await client.patch(`/school-timings/${id}`, payload);
    return data;
  },

  async activate(id) {
    const { data } = await client.patch(`/school-timings/${id}/activate`);
    return data;
  },

  async remove(id) {
    const { data } = await client.delete(`/school-timings/${id}`);
    return data;
  },

  async getAttendanceWindow(type = "student") {
    const { data } = await client.get("/school-timings/attendance-window", { params: { type } });
    return data;
  },
};

export default schoolTimingsApi;
